<template>
    <div id="dialog">
      <v-btn color="primary" dark @click="dialog = true">Novo</v-btn>

      <v-dialog v-model="dialog" width="550" persistent>
        <v-card>
          <v-card-title primary-title class="pl-3">
            <v-btn color="#111" class="mr-3" icon @click="fecharDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span>Mapa Separação</span>
          </v-card-title>

          <v-divider class="mb-8"></v-divider>

          <v-card-text>

            <div class="d-flex">
              <v-col cols="6" class="pa-0 pr-2">
                <v-select
                  v-model="editedItem.grupos"
                  :items="selects.grupos.items"
                  id="grupos"
                  height="10"
                  label="Selecione o Grupo"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  chips
                  :disabled="edited"
                  :error-messages="gruposErrors"
                  @input="$v.editedItem.grupos.$touch()"
                  @blur="$v.editedItem.grupos.$touch()"
                  @change="buscarFiliaisDoGrupo()"
                ></v-select>
              </v-col>

              <v-col cols="6" class="pa-0 pl-2">
                <v-select
                  v-model="editedItem.filial_destino"
                  :items="selects.filial.items"
                  id="filial"
                  label="Filial de Destino"
                  item-text="filial"
                  item-value="id"
                  outlined
                  :disabled="edited"
                  :error-messages="filialDestinoErrors"
                  @input="$v.editedItem.filial_destino.$touch()"
                  @blur="$v.editedItem.filial_destino.$touch()"
                ></v-select>
              </v-col>
            </div>

            <v-autocomplete
              outlined
              multiple
              v-model="editedItem.filial_origem"
              :items="itemsFiliaisCds"
              id="filial_cd"
              item-text="filial"
              item-value="id"
              label="Filial de Origem"
              :error-messages="filialCdErrors"
              @input="$v.editedItem.filial_origem.$touch()"
              @blur="$v.editedItem.filial_origem.$touch()"
            ></v-autocomplete>

          </v-card-text>

          <v-card-actions class="mt-n5">
            <div class="flex-grow-1"></div>
            <v-btn text @click="fecharDialog()">Fechar</v-btn>
            <v-btn color="primary" text @click="salvarGrupoFilialSeparacao()">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import FilialAPI from "../../api/filial";
import Api from "../../api/cfg"
import DrpAPI from "../../api/drp.js"
import { required } from "vuelidate/lib/validators"

export default {
  name: "AbrirDialogMapaCompra",
  model: {
    prop: 'dialog',
    event: 'change',
  },
  props: {
    itemParaEdicao: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    dialog: false,
    edited: false,
    editedItem: {
      grupos: "",
      filial_destino: "",
      filial_origem: [],
    },
    selects: {
      grupos: {
        items: [],
      },
      filial: {
        items: [],
      },
      filial_cd: {
        items: [],
      }
    }
  }),

  validations: {
    editedItem: {
      grupos: { required },
      filial_destino: { required },
      filial_origem: { required },
    },
  },
  computed: {
    gruposErrors() {
      const errors = [];
      if (!this.$v.editedItem.grupos.$dirty) return errors;
      !this.$v.editedItem.grupos.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialDestinoErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial_destino.$dirty) return errors;
      !this.$v.editedItem.filial_destino.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialCdErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial_origem.$dirty) return errors;
      !this.$v.editedItem.filial_origem.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    itemsFiliaisCds () {
      return this.selects.filial.items.filter(item => item.filial != this.editedItem.filial_destino)
    }
  },
  watch: {

    atualizarApp() {
      this.initialize();
    },
    itemParaEdicao (novoValor) {
      this.dialog = true;
      if(this.dialog) {
        this.edited = true
      }
      this.editedItem = {...novoValor}
      this.buscarFiliaisDoGrupo()
    },
  },

  created() {
    this.initialize();
  },
  methods:  {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        Api.getGrupos(headers)
          .then((response) => {
            const {token, grupos} = response.data;
            localStorage.setItem("token", token);
            this.selects.grupos.items = grupos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    buscarFiliaisDoGrupo() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {grupo: this.editedItem.grupos};

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const { token, filiais } = response.data;
            localStorage.setItem("token", token);
            this.selects.filial.items = filiais;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    salvarGrupoFilialSeparacao() {

      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          filial_destino: this.editedItem.filial_destino,
          filial_origem: this.editedItem.filial_origem,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          FilialAPI.salvarGrupoFilialSeparacao(headers, params)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);
              this.$emit("salvo-com-sucesso", {});
              this.fecharDialog()
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    fecharDialog () {
      this.dialog = false;
      this.edited = false;
      this.$v.$reset();
      this.editedItem.grupos = "";
      this.editedItem.filial_destino = "";
      this.editedItem.filial_origem = [];
    }
  }
}
</script>

<style>

</style>
